import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.settings');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-settings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.settings/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageSettingsComponent implements OnInit {
    public isAdmin: boolean = false;
    public activeSettingsTab: string = 'general';
    public activeChatbotProvider: string = 'openai';
    public currentTheme: string = 'b';
    public currentMode: string = 'light';
    public currentFontSize: string = 'medium';
    public quickToolEnabled: boolean = true;
    public notificationsEnabled: boolean = true;
    public reportNotificationsEnabled: boolean = true;
    public chatbotSaving: boolean = false;
    public chatbotChecking: boolean = false;
    public showOpenaiApiKey: boolean = false;
    public chatbotMessage: string = '';
    public chatbotError: string = '';

    public chatbotSettings: any = {
        provider: 'openai',
        provider_label: 'OPEN AI API',
        openai_api_key: '',
        openai_api_key_masked: '',
        openai_model: '',
        gpu_server_url: '',
        local_model_server: '',
        connection_status: 'missing',
        connection_label: '설정 필요',
        connection_message: '선택한 방식의 필수 입력값이 부족합니다.',
        last_checked_at: ''
    };
    private savedChatbotSettings: any = { ...this.chatbotSettings };

    public themes: any[] = [
        { id: 'a', letter: 'A', label: '따뜻한 한의원', desc: '호박빛과 약초 그린 조합', color: '#c27a1a' },
        { id: 'b', letter: 'B', label: '깔끔한 디지털 헬스', desc: '민트와 스카이 기반 모던 톤', color: '#10b981' },
        { id: 'c', letter: 'C', label: '감성 파스텔', desc: '라벤더와 스카이 파스텔 톤', color: '#8b5cf6' }
    ];

    public modes: any[] = [
        { id: 'light', icon: 'sun', label: '라이트 모드', desc: '밝고 선명한 화면' },
        { id: 'dark', icon: 'moon', label: '다크 모드', desc: '눈부심을 줄인 화면' }
    ];

    public fontSizes: any[] = [
        { id: 'small', label: '작게', desc: '조금 더 촘촘하게' },
        { id: 'medium', label: '보통', desc: '기본 권장 크기' },
        { id: 'large', label: '크게', desc: '더 크게 확대' }
    ];

    public chatbotProviders: any[] = [
        { id: 'openai', label: 'OPEN AI API 설정', desc: 'API Key와 모델을 사용합니다.' },
        { id: 'gpu', label: 'GPU 서버 설정', desc: 'GPU 서버와 로컬 모델 서버를 사용합니다.' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.currentTheme = localStorage.getItem('app-theme') || 'b';
        this.currentMode = localStorage.getItem('app-mode') || 'light';
        this.currentFontSize = localStorage.getItem('app-font-size') || 'medium';
        this.quickToolEnabled = localStorage.getItem('app-quick-tool-enabled') !== 'off';
        this.notificationsEnabled = localStorage.getItem('app-notifications') !== 'off';
        this.reportNotificationsEnabled = localStorage.getItem('app-report-notifications') !== 'off';
        await this.loadChatbotSettings();
        await this.service.render();
    }

    public goBack() {
        this.service.href('/mypage');
    }

    public async changeTheme(themeId: string) {
        this.currentTheme = themeId;
        localStorage.setItem('app-theme', themeId);
        const container = document.querySelector('.app-container');
        if (container) {
            container.setAttribute('data-theme', themeId);
        }
        window.dispatchEvent(new CustomEvent('app-theme-change', { detail: themeId }));
        await this.service.render();
    }

    public async changeMode(modeId: string) {
        this.currentMode = modeId;
        localStorage.setItem('app-mode', modeId);
        const container = document.querySelector('.app-container');
        if (container) {
            container.setAttribute('data-mode', modeId);
        }
        window.dispatchEvent(new CustomEvent('app-mode-change', { detail: modeId }));
        await this.service.render();
    }

    public async changeFontSize(fontSizeId: string) {
        this.currentFontSize = fontSizeId;
        localStorage.setItem('app-font-size', fontSizeId);
        const containers = document.querySelectorAll('.app-container, .auth-container');
        containers.forEach((container) => {
            (container as HTMLElement).setAttribute('data-font-size', fontSizeId);
        });
        window.dispatchEvent(new CustomEvent('app-font-size-change', { detail: fontSizeId }));
        await this.service.render();
    }

    public async toggleQuickToolEnabled() {
        this.quickToolEnabled = !this.quickToolEnabled;
        localStorage.setItem('app-quick-tool-enabled', this.quickToolEnabled ? 'on' : 'off');
        window.dispatchEvent(new CustomEvent('app-quick-tool-enabled-change', { detail: this.quickToolEnabled }));
        await this.service.render();
    }

    public async toggleNotifications() {
        this.notificationsEnabled = !this.notificationsEnabled;
        localStorage.setItem('app-notifications', this.notificationsEnabled ? 'on' : 'off');
        await this.service.render();
    }

    public async toggleReportNotifications() {
        this.reportNotificationsEnabled = !this.reportNotificationsEnabled;
        localStorage.setItem('app-report-notifications', this.reportNotificationsEnabled ? 'on' : 'off');
        await this.service.render();
    }

    public async toggleOpenaiApiKeyVisibility() {
        this.showOpenaiApiKey = !this.showOpenaiApiKey;
        await this.service.render();
    }

    public async loadChatbotSettings() {
        try {
            let res = await wiz.call("chatbot_settings");
            if (res.code === 200 && res.data) {
                this.isAdmin = true;
                this.applyChatbotSettings(res.data.data || res.data);
            }
        } catch {
            this.isAdmin = false;
        }
    }

    private stopInteraction(event?: Event) {
        if (!event) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    }

    public applyChatbotSettings(data: any, remember: boolean = true) {
        this.chatbotSettings = { ...this.chatbotSettings, ...data, openai_api_key: '' };
        this.activeChatbotProvider = this.chatbotSettings.provider || 'openai';
        if (remember) {
            this.savedChatbotSettings = { ...this.chatbotSettings };
        }
    }

    private restoreSavedChatbotSettings() {
        this.chatbotSettings = { ...this.savedChatbotSettings, openai_api_key: '' };
        this.activeChatbotProvider = this.chatbotSettings.provider || 'openai';
    }

    public async switchSettingsTab(tab: string) {
        this.activeSettingsTab = tab;
        this.chatbotMessage = '';
        this.chatbotError = '';
        await this.service.render();
    }

    public async selectChatbotProvider(provider: string) {
        this.activeChatbotProvider = provider;
        this.chatbotSettings.provider = provider;
        this.chatbotMessage = '';
        this.chatbotError = '';
        await this.service.render();
    }

    public selectedProviderLabel(): string {
        const provider = this.chatbotProviders.find((item) => item.id === this.activeChatbotProvider);
        return provider ? provider.label.replace(' 설정', '') : 'OPEN AI API';
    }

    public connectionBadgeClass(): string {
        const status = this.chatbotSettings.connection_status;
        if (status === 'connected') return 'bg-green-100 text-green-700 border-green-200';
        if (status === 'failed') return 'bg-red-100 text-red-700 border-red-200';
        if (status === 'checking') return 'bg-blue-100 text-blue-700 border-blue-200';
        if (status === 'ready') return 'bg-amber-100 text-amber-700 border-amber-200';
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }

    public async saveChatbotSettings(clearOpenaiApiKey: boolean = false, event?: Event) {
        this.stopInteraction(event);
        this.chatbotSaving = true;
        this.chatbotMessage = '';
        this.chatbotError = '';
        await this.service.render();

        try {
            let res = await wiz.call("save_chatbot_settings", {
                provider: this.activeChatbotProvider,
                openaiApiKey: this.chatbotSettings.openai_api_key || '',
                clearOpenaiApiKey: String(clearOpenaiApiKey),
                openaiModel: this.chatbotSettings.openai_model || '',
                gpuServerUrl: this.chatbotSettings.gpu_server_url || '',
                localModelServer: this.chatbotSettings.local_model_server || ''
            });

            if (res.code === 200 && res.data) {
                this.applyChatbotSettings(res.data.data || res.data);
                this.chatbotMessage = '챗봇 설정을 저장했습니다.';
            } else {
                this.chatbotError = res.data?.message || '챗봇 설정 저장에 실패했습니다.';
            }
        } catch {
            this.chatbotError = '챗봇 설정 저장에 실패했습니다.';
        }

        this.chatbotSaving = false;
        await this.service.render();
    }

    public async checkChatbotConnection(event?: Event) {
        this.stopInteraction(event);
        this.chatbotChecking = true;
        this.chatbotSettings.connection_status = 'checking';
        this.chatbotSettings.connection_label = '확인 중';
        this.chatbotSettings.connection_message = this.activeChatbotProvider === 'openai'
            ? 'OPEN AI API 키와 모델로 실제 응답 생성을 확인하고 있습니다. 연결 성공 시 자동 저장됩니다.'
            : '서버 응답, 모델 목록, 짧은 생성 테스트를 확인하고 있습니다. 연결 성공 시 자동 저장됩니다.';
        this.chatbotMessage = this.chatbotSettings.connection_message;
        this.chatbotError = '';
        await this.service.render();

        try {
            let res = await wiz.call("check_chatbot_connection", {
                provider: this.activeChatbotProvider,
                openaiApiKey: this.chatbotSettings.openai_api_key || '',
                openaiModel: this.chatbotSettings.openai_model || '',
                gpuServerUrl: this.chatbotSettings.gpu_server_url || '',
                localModelServer: this.chatbotSettings.local_model_server || ''
            });
            if (res.code === 200 && res.data) {
                const data = res.data.data || res.data;
                if (data.saved) {
                    this.applyChatbotSettings(data);
                    this.chatbotMessage = this.chatbotSettings.connection_message;
                    this.chatbotError = '';
                } else {
                    this.applyChatbotSettings(data);
                    this.chatbotMessage = '';
                    this.chatbotError = `${this.chatbotSettings.connection_message}\n기존 설정을 유지했습니다.`;
                }
            } else {
                this.restoreSavedChatbotSettings();
                this.chatbotMessage = '';
                this.chatbotError = `${res.data?.message || '연결 확인에 실패했습니다.'}\n기존 설정을 유지했습니다.`;
            }
        } catch {
            this.restoreSavedChatbotSettings();
            this.chatbotMessage = '';
            this.chatbotError = '연결 확인에 실패했습니다.\n기존 설정을 유지했습니다.';
        }

        this.chatbotChecking = false;
        await this.service.render();
    }
}

export default PageSettingsComponent;